import React from 'react';

// state
import { useAppSelector } from '../../../store/hooks';
import {} from '../../../service/api/report';

// components
import MiniButton from '../../../components/elements/forms/MiniButton';
import RichTextInputBox from '../../../components/elements/forms/RichTextInputBox';

type IUpdatePurpose = {
	onSubmit: (data: string) => void;
};

const UpdatePurpose: React.FC<IUpdatePurpose> = ({ onSubmit }) => {
	const [show, showSet] = React.useState<boolean>();
	const [data, dataSet] = React.useState<string>('');
	const report_stats = useAppSelector(({ report }) => report.report_stats);

	const onLoad = React.useCallback(() => {
		if (report_stats?.purpose) dataSet(report_stats?.purpose);
	}, [report_stats?.purpose]);

	React.useEffect(() => {
		onLoad();
	}, [onLoad]);

	return (
		<div>
			<div>
				{!show ? (
					report_stats?.purpose ? (
						<div
							dangerouslySetInnerHTML={{
								__html: report_stats.purpose
							}}
						/>
					) : (
						<div />
					)
				) : (
					<RichTextInputBox
						value={data}
						placeholder="Enter Purpose"
						status=""
						onChange={(e) => dataSet(e)}
					/>
				)}
			</div>
			<div>
				<div className="w-full flex justify-end my-2">
					<div className="w-[15%]">
						<MiniButton
							title={!show ? 'Edit' : 'Update'}
							onHandler={() => {
								if (show) {
									onSubmit(data);
									showSet(false);
								} else {
									showSet(true);
								}
							}}
							backgroundColor="#CDD8FE"
							textColor="#243677"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpdatePurpose;
